import { useMemo } from 'react';
import { Modal } from '@Sage/hoi-poi-ui';

import './styles.scss';

const VideoModal = ({ autoPlay = true, isOpen, onRequestClose, title, videoUrl }) => {
    const finalVideoUrl = useMemo(() => {
        if (!videoUrl || !autoPlay) return videoUrl;

        try {
            const urlObj = new URL(videoUrl);
            urlObj.searchParams.set('autoplay', '1');
            return urlObj.toString();
        } catch {
            return videoUrl;
        }
    }, [videoUrl, autoPlay]);

    const classes = useMemo(
        () => ({
            content: 'fm-video-modal__content',
        }),
        [],
    );

    if (!finalVideoUrl) return null;

    return (
        <Modal
            classes={classes}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            overlayClassName="fm-video-modal__overlay"
            size="large"
            title={title}
            useCornerClose
            useHeader
        >
            <div className="fm-video-modal__video">
                <iframe
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="fm-video-modal__iframe"
                    frameBorder="0"
                    src={finalVideoUrl}
                    title={title}
                />
            </div>
        </Modal>
    );
};

VideoModal.displayName = 'VideoModal';

export default VideoModal;
